import {useIntl} from 'react-intl';

export const TABLE_SCROLL_HEIGHT = 320;
export const COMPUTED_PAGE_SIZE = 50;

/** Mensaje de tabla vacía: distingue "no hay nada" de "el filtro no encontró". */
export function emptyMessageId(filtersActive) {
    return filtersActive
        ? 'RELEVANCE.PROMOTED_FILTERED_EMPTY'
        : 'RELEVANCE.PROMOTED_TABLE_EMPTY';
}

/** "Sí" / "No" traducido para una bandera booleana. */
export function YesNo({value}) {
    const intl = useIntl();
    return intl.formatMessage({
        id: value
            ? 'RELEVANCE.PROMOTED_AUTO_RANKING_ON'
            : 'RELEVANCE.PROMOTED_AUTO_RANKING_OFF',
    });
}

/** Bandas que el motor puede promover (espejo de `isPromotableBand`). */
const PROMOTABLE_BANDS = ['featured', 'cooling'];

/**
 * Por qué una fila de computados no llega al carrusel, como ids de mensaje.
 * "Nivel" es la banda del score y no cambia con la elegibilidad (histéresis),
 * así que un "Destacado" puede no promoverse: esto lo explica.
 *
 * Orden de las causas igual que `runScore` en oasis-api: banda, elegibilidad
 * (oferta sin vender, compradores pagados), ranking automático y, si nada de
 * eso falla, es que el evento ya está en la lista manual. `eligibility` es
 * `null` en filas anteriores a `relevance-eligibility-floor`.
 */
export function notPromotedReasonIds(event) {
    if (event.wouldPromote) return [];
    if (!PROMOTABLE_BANDS.includes(event.band)) {
        return ['RELEVANCE.PROMOTED_REASON_BELOW_THRESHOLD'];
    }
    const reasons = (event.eligibility && event.eligibility.reasons) || [];
    if (reasons.length > 0) {
        return reasons.map((reason) =>
            reason === 'sold_out'
                ? 'RELEVANCE.PROMOTED_REASON_SOLD_OUT'
                : reason === 'below_paid_buyers'
                ? 'RELEVANCE.PROMOTED_REASON_BELOW_PAID_BUYERS'
                : reason,
        );
    }
    if (!event.autoRankingEnabled) {
        return ['RELEVANCE.PROMOTED_REASON_AUTO_RANKING_OFF'];
    }
    return ['RELEVANCE.PROMOTED_REASON_MANUAL'];
}
